<!-- new theme implementation starts -->
<div class="subheader with-padding flgrow">
    <div class="row align-items-center">
      <div class="col-sm-3">
        <div class="flmid">
          <div class="input-group">
            <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblSearch' | translate }}"
              [(ngModel)]="pService.searchTerm" autocomplete="off" />
            <div class="input-group-append">
              <button type="button" class="btn btn-primary">
                <em class="fa fa-search"></em>
              </button>
            </div>
          </div>
  
        </div>
  
      </div>
      <div class="col-sm-3 pl-4">
        <div class="relative">
        </div>
      </div>
      <div class="col-auto ml-auto">
        <button type="button" type="reset" class="add-button btn btn-primary" aria-label="Center Align" translate
          (click)="onAdd()">lblAddCategory</button>
      </div>
  
    </div>
  </div>
  
  <div class="container prel">
    <div class="row">
      <div class="c12">
        <div class="card mb-3">
          <div class="card-header d-flex">
            <h4 class="card-title" translate>lblCategory</h4>
          </div>
          <div class="table-responsive">
            <table class="tablest1">
              <thead>
                <tr>
                  <th style="width: 55px" scope="col">#</th>
                  <th style="width: 20%"  scope="col" (sort)="onSort($event)" translate>lblCategoryName</th>
                  <th style="width: 20%" scope="col" translate>lblCategoryDescription</th>
                  <th style="width: 10%" scope="col" translate>lblActive</th>
                  <th style="width: 120px" scope="col" class="text-center" translate>lblAction</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="categoryList?.length>0; else load_else">
                  <tr *ngFor="let category of categoryList; let i=index">
                    <td>{{category.rowNumber}}</td>
                    <td>
                      <ngb-highlight [result]="category.categoryName" [term]="pService.searchTerm"></ngb-highlight>
                    </td>
                    <td>
                      <ngb-highlight [result]="category.categoryDescription" [term]="pService.searchTerm"></ngb-highlight>
                    </td>
                    <td>
                      <div class='lbl-info'>
                        <div class="custom-control custom-switch">
                          <ng-container>
                            <input type="checkbox" class="custom-control-input" name="CheckBreak-{{i}}"
                              id="CheckBreak-{{i}}" [(ngModel)]="category.isActive"
                              (click)="onActiveOrInactive(category.id)" />
                            <label class="custom-control-label mr-1" for="CheckBreak-{{i}}">
                              <span *ngIf="category.isActive" translate>lblYes</span>
                              <span *ngIf="!category.isActive" translate>lblNo</span>
                            </label>
                          </ng-container>
                        </div>
                      </div>
                    </td>
                    <td class="nowrap text-center">
                      <a class="btn btn-ico" ngbTooltip="Edit" tooltipClass="custom-revert"
                        *ngIf="userRoleRightsDetails.canEdit" (click)="onEdit(category.id)">
                        <em class="fas fa-pencil-alt fa-lg"></em>
                      </a>
                      <span class="ico-div" *ngIf="userRoleRightsDetails.canDelete"></span>
                      <a class="btn btn-ico" ngbTooltip="Delete" tooltipClass="custom-revert"
                        *ngIf="userRoleRightsDetails.canDelete" (click)="deleteCategory(category.id)">
                        <em class="far fa-trash-alt fa-lg"></em>
                      </a>
                    </td>
                  </tr>
                </ng-container>
                <ng-template #load_else>
                  <tr>
                    <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                  </tr>
                </ng-template>
              </tbody>
            </table>
          </div>
          <div class="card-footer">
            <div class="d-flex justify-content-between">
              <div class="d-flex justify-content-between">
                <ngb-pagination [collectionSize]="pService.total$  | async" [(page)]="pService.page"
                  [pageSize]="pService.pageSize" [maxSize]="3">
                </ngb-pagination>
                <select class="custom-select mx-2" style="width: auto" name="pageSize" [(ngModel)]="pService.pageSize">
                  <option *ngFor="let item of pService.pageItemsArray" [ngValue]="item.values" translate>{{item.label}}
                  </option>
                </select>
              </div>
              <div class="d-flex justify-content-between p-2 font17 fontbold" style="margin: auto 0;">
                <span class="font17 fontnormal" translate>lblTotal</span>:&nbsp;{{pService.total$ | async}}&nbsp;<span
                  class="font17 fontnormal" translate>lblResults</span>
              </div>
  
            </div>
          </div>
        </div>
  
      </div>
    </div>
  
  </div>
  <!-- new theme implementation ends -->
  
  <!-- pdf view-->
